import {
  ElementType,
  SLATE_CODE_BLOCK_CLASSNAME,
} from "@easy-email-pro-core/constants";
import {
  TextNode,
  Element as NodeElement,
  ElementDefinition,
} from "@easy-email-pro-core/typings";

import { get } from "lodash";

import he from "he";
import { BlockManager } from "@easy-email-pro-core/utils/BlockManager";
import { HtmlNodeAdapter, getDOMNode } from "./HtmlNodeAdapter";

export function mjmlToBlockElement(mjml: string) {
  if (!mjml.trim()) {
    return { text: "" };
  }
  const domParse = new DOMParser();

  // firefox 不允许 &nbsp; 这种实体, 链接中包含 & ，会 break
  const formatMJml = mjml.replace(/&nbsp;/g, " ").replace(/&/g, "&amp;");
  // .replace(/</g, "&lt;")
  // .replace(/>/g, "&gt;")
  // .replace(/"/g, "&quot;")
  // .replace(/'/g, "&apos;")

  const doc = domParse.parseFromString(formatMJml, "text/xml");

  const mjmlHandler = (node: ChildNode): NodeElement | TextNode => {
    if (!node) {
      return { text: "" };
    }
    if (node.nodeType === 8) {
      const rowBlock = BlockManager.getBlockByType(ElementType.RAW);
      return rowBlock.create({ data: { content: node.textContent || "" } });
    }
    if (node.nodeType === 3) {
      return { text: node.textContent || "" };
    }

    if (node.nodeType !== 1) {
      console.log("Invalid Node", node, node.nodeType);
      throw new Error("Invalid Node");
    }
    const element = node as HTMLElement;

    if (!element.tagName.toLocaleLowerCase().startsWith("mj-")) {
      return getDOMNode(element, mjmlHandler);
    }

    let data = {} as any;
    let type = element.tagName.toLocaleLowerCase().replace("mj-", "") as any;

    let attributes = element
      .getAttributeNames()
      .filter((item) => !item.startsWith("element-"))
      .reduce((obj, key) => {
        return { ...obj, [key]: element.getAttribute(key) || "" };
      }, {} as any);

    if (element.getAttribute("element-type")) {
      type = element.getAttribute("element-type");
    }

    if (element.getAttribute("element-data")) {
      data = JSON.parse(
        decodeURIComponent(element.getAttribute("element-data")!)
      );
    }

    if (element.getAttribute("element-attributes")) {
      attributes =
        JSON.parse(
          decodeURIComponent(element.getAttribute("element-attributes")!)
        ) || {};
    }

    if (
      type === ElementType.TEXT &&
      get(attributes, "css-class", "").includes(SLATE_CODE_BLOCK_CLASSNAME)
    ) {
      type = ElementType.DANGEROUS_CODE;
      data = {
        code: he.decode(element.innerHTML),
      };
    }

    if (element.tagName.toLocaleLowerCase() === "mj-table") {
      type = ElementType.TABLE;
      data = {
        code: he.decode(element.innerHTML),
      };
    }

    const matchBlock = BlockManager.getBlockByType(type) as
      | ElementDefinition
      | undefined;

    if (!matchBlock) {
      throw new Error(`Don't support ${element.tagName.toLocaleLowerCase()}`);
    }
    let children = [];
    switch (type) {
      case ElementType.TEXT:
      case ElementType.BUTTON:
      case ElementType.NAVBAR_LINK:
      case ElementType.SOCIAL_ELEMENT:
        children = HtmlNodeAdapter(element.innerHTML || "", mjmlHandler);
        break;
      default:
        children = matchBlock.void
          ? []
          : element.childNodes.length > 0
            ? [...element.childNodes].map(mjmlHandler)
            : [];
    }

    return {
      type: type,
      data: data,
      attributes: attributes,
      children: children as any,
    };
  };
  return mjmlHandler(doc.firstChild as HTMLElement);
}
